
export const OPEN_COLOR_PICKER_EVENT_NAME = 'openPicker';

export class OpenColorPickerEvent extends Event {
    constructor() {
        super(OPEN_COLOR_PICKER_EVENT_NAME);
    }
}
